import { DateRangeFormat } from '@intentsify/types';
import { DateTime, Interval, Settings } from 'luxon';
Settings.defaultLocale = 'en-US';
export var formatDateRange = function (range, format) {
    if (format === void 0) { format = DateRangeFormat.StartEndDateMonth; }
    var startDate = DateTime.fromISO(range.start, { zone: 'utc' });
    var endDate = DateTime.fromISO(range.end, { zone: 'utc' });
    switch (true) {
        case format === DateRangeFormat.Dates: {
            var start = startDate.toISODate();
            var end = endDate.toISODate();
            return "".concat(start, " \u2014 ").concat(end);
        }
        case format === DateRangeFormat.StartDate: {
            var start = startDate.toISODate();
            return start;
        }
        case format === DateRangeFormat.StartDateMonth: {
            var start = startDate.toFormat('DD');
            return start;
        }
        case format === DateRangeFormat.StartEndDateMonth: {
            var start = startDate.toFormat('DD');
            var end = endDate.toFormat('DD');
            return "".concat(start, " \u2014 ").concat(end);
        }
        case format === DateRangeFormat.StartEndDateMonthDash: {
            var start = startDate.toFormat('DD');
            var end = endDate.toFormat('DD');
            return "".concat(start, "_").concat(end).replace(/\s/g, '-').replace(/,/g, '');
        }
        case format === DateRangeFormat.WeekNumber: {
            var interval = Interval.fromDateTimes(startDate, endDate);
            var weeks = interval.splitBy({ weeks: 1 });
            return "Week ".concat(weeks.map(function (w) { return w.start.weekNumber; }).join(', '));
        }
        case format === DateRangeFormat.Month: {
            var interval = Interval.fromDateTimes(startDate, endDate);
            var weeks = interval.splitBy({ weeks: 1 });
            return "".concat(weeks
                .map(function (w) {
                var months = Array.from(new Set([w.start.monthShort, w.end.monthShort])).join(' / ');
                return months;
            })
                .join(', '));
        }
    }
    return "".concat(range.start, " - ").concat(range.end);
};
//# sourceMappingURL=formatDateRange.js.map